export default {
  // 菜单
  'menu.aes': 'AES',
  'menu.aes.new': '新建 AES',
  'menu.aes.list': 'AES 列表',
  'menu.aes.aes_new': '新建 AES',
  'menu.aes.aes_list': '搜索',

  // 页签 / 分区
  'aes.tab.info': '基本信息',
  'aes.tab.documents': '文件',
  'aes.section.filing': '申报与货运信息',
  'aes.section.transport': '运输信息',
  'aes.section.parties': '相关方',
  'aes.section.commodity_items': '商品明细',
  'aes.contact.section': 'AES 设置',
  'aes.contact.id_type': 'AES 编号类型',
  'aes.contact.id_no': 'AES 编号',

  // 申报与货运字段
  'aes.field.filer_ein_type': '申报人编号类型',
  'aes.field.filer_ein': '申报人编号',
  'aes.field.filing_option': '申报方式',
  'aes.field.aei_filing_type': 'AEI 申报类型',
  'aes.field.shipment_file_number': '申报文件号',
  'aes.field.shipment_number': '货运编号',
  'aes.field.itn_no': 'ITN 号',
  'aes.field.mode_of_transport_code': '运输方式',
  'aes.field.op_type': '业务类型',
  'aes.field.ultimate_country': '最终目的国',
  'aes.field.state_of_origin': '原产州',
  'aes.field.carrier': '承运人',
  'aes.field.carrier_code': '承运人代码（SCAC/IATA）',
  'aes.field.carrier_qualifier': '承运人代码类型',
  'aes.field.vessel': '船名 / 运输工具',
  'aes.field.port_of_loading': '装货港（POL）',
  'aes.field.loading_date': '装货日期',
  'aes.field.port_of_discharge': '卸货港（POD）',
  'aes.field.discharge_date': '卸货日期',
  'aes.field.routed_export_indicator': '委托出口交易',
  'aes.field.related_company_indicator': '关联公司',
  'aes.field.hazmat_indicator': '危险品',
  'aes.field.inbond_type': '保税运输类型',
  'aes.field.inbond_number': '保税运输编号',
  'aes.field.foreign_trade_zone': '对外贸易区（FTZ）',
  'aes.field.entry_number': 'Entry No.',
  'aes.field.master_bill_number': 'MB/L 号',

  // 申报选项
  'aes.option.filing.2': '2 - 装运前完整申报',
  'aes.option.filing.3': '3 - 提前出口信息申报（AEI）',
  'aes.option.filing.4': '4 - 装运后申报',
  'aes.option.aei.P': 'P - 装运前部分申报',
  'aes.option.aei.F': 'F - 装运后完整申报',
  'aes.option.op.OE': 'OE - 海运出口',
  'aes.option.op.AE': 'AE - 空运出口',
  'aes.option.op.DO': 'DO - 国内运输',
  'aes.option.mot.10': '10 - 海运',
  'aes.option.mot.11': '11 - 集装箱海运',
  'aes.option.mot.12': '12 - 驳船运输',
  'aes.option.mot.20': '20 - 铁路运输',
  'aes.option.mot.21': '21 - 集装箱铁路运输',
  'aes.option.mot.30': '30 - 卡车运输',
  'aes.option.mot.31': '31 - 集装箱卡车运输',
  'aes.option.mot.32': '32 - 汽车运输',
  'aes.option.mot.33': '33 - 行人携带',
  'aes.option.mot.34': '34 - 其他公路运输',
  'aes.option.mot.40': '40 - 空运',
  'aes.option.mot.41': '41 - 集装箱空运',
  'aes.option.mot.50': '50 - 邮寄',
  'aes.option.mot.60': '60 - 旅客随身携带',
  'aes.option.mot.70': '70 - 固定设施运输',
  'aes.option.inbond.36': '36 - 从保税仓提货后立即出口（IE）',
  'aes.option.inbond.37': '37 - 从保税仓提货后运输并出口（T&E）',
  'aes.option.inbond.67': '67 - 从外贸区提货后立即出口（IE）',
  'aes.option.inbond.68': '68 - 从外贸区提货后运输并出口（T&E）',
  'aes.option.inbond.70': '70 - 非保税运输',

  // 相关方
  'aes.party.usppi': '美国主要利益方（USPPI）',
  'aes.party.forwarding_agent': '货运代理',
  'aes.party.ultimate_consignee': '最终收货人',
  'aes.party.intermediate_consignee': '中间收货人',
  'aes.field.ultimate_consignee_type': '最终收货人类型',
  'aes.option.consignee.D': 'D - 直接消费者',
  'aes.option.consignee.G': 'G - 政府机构',
  'aes.option.consignee.O': 'O - 其他 / 未知',
  'aes.option.consignee.R': 'R - 经销商',

  // 商品字段
  'aes.field.commodity.hts_number': 'Schedule B / HTS 编码',
  'aes.field.commodity.description': '商品描述',
  'aes.field.commodity.qty1': '数量 1',
  'aes.field.commodity.qty1_unit': '数量单位 1',
  'aes.field.commodity.qty2': '数量 2',
  'aes.field.commodity.qty2_unit': '数量单位 2',
  'aes.field.commodity.origin': '货物原产属性',
  'aes.field.commodity.value': '价值（美元）',
  'aes.field.commodity.gross_weight': '毛重（公斤）',
  'aes.field.commodity.export_code': '出口代码',
  'aes.field.commodity.license_type': '许可证类型',
  'aes.field.commodity.eccn': '出口管制分类编码（ECCN）',
  'aes.field.commodity.license_number': '许可证号',
  'aes.option.origin.D': 'D - 美国境内',
  'aes.option.origin.F': 'F - 美国境外',
  'aes.commodity.add': '添加商品',
  'aes.commodity.edit': '编辑商品',
  'aes.commodity.empty': '请至少添加一项商品。',

  // 状态 / 列表
  'aes.title.new': '新建',
  'aes.field.status': '状态',
  'aes.list.ext_id': '申报文件号',
  'aes.list.shipment_number': '货运编号',
  'aes.list.op_type': '业务类型',
  'aes.list.carrier': '承运人',
  'aes.list.port_of_loading': '装货港',
  'aes.list.port_of_discharge': '卸货港',
  'aes.list.create': '新建',

  // 提示
  'aes.save.success': 'AES 保存成功',
  'aes.save.error': 'AES 保存失败',
  'aes.update.success': 'AES 更新成功',
  'aes.submit.success': 'AES 提交成功',
  'aes.submit.error': 'AES 提交失败',
  'aes.submit.save_first': '请先保存 AES，再进行提交。',
  'aes.delete.success': 'AES 已删除',
  'aes.delete.confirm': '确定删除这条 AES 申报吗？',
  'aes.parties.required': '美国主要利益方和最终收货人为必填项（至少两个相关方）。',
  'aes.parties.incomplete': '请先补全以下 AES 联系人资料：{parties}。',
  'aes.contact_status.title': '联系人资料状态',
  'aes.contact_status.complete': '✓ AES 申报资料完整',
  'aes.contact_status.missing': '缺少：{fields}',
  'aes.contact_status.incomplete': '提交 AES 前必须补全该联系人资料。',
  'aes.contact_status.missing.name': '名称',
  'aes.contact_status.missing.address': '地址',
  'aes.contact_status.missing.country': '国家',
  'aes.contact_status.missing.us_country': '国家必须为美国',
  'aes.contact_status.missing.aes_id': 'AES 编号类型和编号',
  'aes.contact_status.missing.ultimate_consignee_type': '最终收货人类型',
  'aes.action.refresh_status': '刷新状态 / ITN',
  'aes.action.gsf_status': '打开 GSF 状态页',
  'aes.itn.refresh.success': 'AES 状态和 ITN 已刷新',
  'aes.itn.not_available': 'ITN 暂未生成',
  'aes.status_url.unavailable': 'GSF 状态页暂不可用',
  'aes.amend.confirm': '确定更正这条 AES 申报并恢复为可编辑状态吗？',
  'aes.amend.success': 'AES 已进入更正状态',
  'aes.changelog.gsf_status': 'CBP/GSF 状态',
};
